import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import LicenseConfig from "./LicenseConfig";
import Plans from "./Plans";
import Features from "./Features";
import Credits from "./Credits";
// import "./staffdashboard.css";




function ConfigurationSales() {

const [selected,setSelected]=useState("license")

  return (
    <>
  <div className="row service-providers-wrapper" style={{minHeight:"70vh",paddingTop:'1%',width:"100%"}}>
  
    <div className="col-3 service-sidecard-wrapper">
    <div className="service-sidecard">
      <div className="service-sidecard-header">
        <div className="service-sidecard-icon">C</div>
        <div>
          <p className="service-sidecard-title">Configuration</p>
          <p className="service-sidecard-subtitle">Plans, credits & features</p>
        </div>
      </div>
      <div className="service-sidecard-menu">
        <button
          className={`patientRecbutton1 service-sidecard-btn ${selected === "license" ? "active" : ""}`}
          onClick={() => setSelected("license")}
        >
          License
        </button>
        <button
          className={`patientRecbutton1 service-sidecard-btn ${selected === "plans" ? "active" : ""}`}
          onClick={() => setSelected("plans")}
        >
          Plans
        </button>
        <button
          className={`patientRecbutton1 service-sidecard-btn ${selected === "credits" ? "active" : ""}`}
          onClick={() => setSelected("credits")}
        >
          Credits
        </button>
        <button
          className={`patientRecbutton1 service-sidecard-btn ${selected === "special_feature" ? "active" : ""}`}
          onClick={() => setSelected("special_feature")}
        >
          Special features
        </button>
      </div>
    </div>
    </div>
    <div className="col-9 service-content-card">
       {selected==="license"?<LicenseConfig/>:selected==="plans" ? <Plans/> :selected==="credits"? <Credits/>: <Features/>}
    </div>
  </div>
    </>
  );
}
export default ConfigurationSales;
